<template>
  <v-app>
    <v-main>
      <component :is="layout"></component>
    </v-main>
  </v-app>
</template>

<script
  async
  src="https://www.googletagmanager.com/gtag/js?id=G-QZPN7XPRYJ"
></script>
<script>
import Layout from './views/layouts/Layout.vue'
import LayoutConfianza from './views/layouts/LayoutConfianza.vue'
import LayoutDocumento from './views/layouts/LayoutDocumento.vue'
import { mapState } from 'vuex'

// window.dataLayer = window.dataLayer || []
// function gtag() {
//   dataLayer.push(arguments)
// }
// gtag('js', new Date())
// gtag('config', 'G-QZPN7XPRYJ')

export default {
  name: 'App',
  components: {
    Layout,
    LayoutDocumento,
    LayoutConfianza,
  },
  computed: {
    ...mapState(['layout']),
  },
  beforeMount() {
    window.addEventListener('beforeunload', (event) => {
      console.log(event.pathname)
      if (
        !(
          event.pathname == '/avanceCredito' ||
          event.pathname == '/terminacionActualizacion' ||
          event.pathname == '/terminacion'
        )
      ) {
        event.preventDefault()
        event.returnValue = ''
      }
    })
  },
}
</script>

<style>
.texto-titulo {
  font-size: 30px;
  line-height: 1.1;
  letter-spacing: 1px;
}
.texto-cuerpo {
  font-size: 30px;
  line-height: 1.1;
  letter-spacing: 2px;
}
</style>
